import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import { MessageProvider } from './contexts/MessageContext'
import Login from './pages/Auth/Login'
import Header from './components/Header'

import AdminUsersList from './pages/AdminUsers/AdminUsersList'
import NewAdminUser from './pages/AdminUsers/NewAdminUser'
import EditAdminUser from './pages/AdminUsers/EditAdminUser'

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth()
  
  console.log('ProtectedRoute - isAuthenticated:', isAuthenticated, 'isLoading:', isLoading)
  
  if (isLoading) {
    return <div>Loading...</div>
  }

  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />
}

function AppContent() {
  const location = useLocation()
  const hideHeaderPaths = ['/login', '/forgot-password', '/reset-password']
  const shouldShowHeader = !hideHeaderPaths.includes(location.pathname)

  return (
    <div className="min-h-screen bg-gray-100">
      {shouldShowHeader && <Header />}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Navigate to="/admin-users" replace />} />
        <Route path="/admin-users" element={
          <ProtectedRoute>
            <AdminUsersList />
          </ProtectedRoute>
        } />
        <Route path="/new-admin-user" element={
          <ProtectedRoute>
            <NewAdminUser />
          </ProtectedRoute>
        } />
        <Route path="/edit-admin-user/:id" element={
          <ProtectedRoute>
            <EditAdminUser />
          </ProtectedRoute>
        } />
      </Routes>
    </div>
  )
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <MessageProvider>
          <AppContent />
        </MessageProvider>
      </AuthProvider>
    </Router>
  )
}

export default App
